import { render } from "./GetPaymentPopup.vue?vue&type=template&id=6cc16955&scoped=true"
import script from "./GetPaymentPopup.vue?vue&type=script&lang=js"
export * from "./GetPaymentPopup.vue?vue&type=script&lang=js"

import "./GetPaymentPopup.vue?vue&type=style&index=0&id=6cc16955&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc16955"]])

export default __exports__